export var AnalyticsViewSource;
(function (AnalyticsViewSource) {
    AnalyticsViewSource["productInfo"] = "product_info";
    AnalyticsViewSource["hamburgerMenu"] = "hamburger_menu";
    AnalyticsViewSource["summaryPage"] = "summary_page";
    AnalyticsViewSource["bookAppointmentSheet"] = "book_appointment_sheet";
    AnalyticsViewSource["paxGuideRecommendations"] = "pax_guide_recommendations";
    AnalyticsViewSource["landingPage"] = "landing_page";
    AnalyticsViewSource["accountName"] = "account_name";
    AnalyticsViewSource["summaryPageAddToCartSheet"] = "summary_page_add_to_cart_sheet";
    AnalyticsViewSource["summaryPageSaveDesignSheet"] = "summary_page_save_design_sheet";
    AnalyticsViewSource["openDesignSheet"] = "open_design_sheet";
    AnalyticsViewSource["saveDesignSheet"] = "save_design_sheet";
    AnalyticsViewSource["saveAsDesignSheet"] = "save_as_design_sheet";
    AnalyticsViewSource["shareDesignSheet"] = "share_design_sheet";
    AnalyticsViewSource["header"] = "header";
    AnalyticsViewSource["bookAppointmentBanner"] = "book_appointment_banner";
    AnalyticsViewSource["summaryButtonClick"] = "summary_button_click";
    AnalyticsViewSource["productMenu"] = "product_menu";
})(AnalyticsViewSource || (AnalyticsViewSource = {}));
//# sourceMappingURL=AnalyticsViewSource.js.map